export function normRoleOrStatus(v) {
  return String(v || '').trim().toUpperCase();
}

export function consumesSeat(member) {
  const role = normRoleOrStatus(member?.role);
  if (role === 'BILLING_ADMIN') return false;
  const status = normRoleOrStatus(member?.status);
  return status === 'ACTIVE' || status === 'INVITED';
}

export function isProductRole(role) {
  const r = normRoleOrStatus(role);
  return r === 'MEMBER' || r === 'ADMIN';
}

export function isAccountPortalRole(role) {
  const r = normRoleOrStatus(role);
  return r === 'ADMIN' || r === 'BILLING_ADMIN';
}
